<div class="p-2 flex items-center justify-center h-14" (click)="session.showPassword=!session.showPassword;  showPasswordAsText(theInputId())">
  @if (session.showPassword) {
    <ism-svg [name]="'eye'" [classString]="'w-8 h-8 text-gray-700'"></ism-svg>
  } @else {
    <ism-svg [name]="'eyeSlash'" [classString]="'w-8 h-8 text-gray-700'"></ism-svg>
  }
</div>
